import style from "styled-components";
import { Link } from "react-router-dom";

export const Card = style(Link)`
  display:flex;
  flex-direction:column;
  text-decoration:none;
`;
export const CartTitle = style.h1`
color:black;
text-align:center;
   font-size:${({ theme }) => theme.fontSizes.medium};
`;
